import React from 'react';
import { motion } from 'framer-motion';

const WeatherBackground = ({ weatherData }) => {
  const getBackgroundGradient = () => {
    if (!weatherData) {
      return 'from-blue-400 via-blue-500 to-blue-600';
    }

    const condition = weatherData.weather[0].main.toLowerCase();
    const hour = new Date().getHours();
    const isDay = hour >= 6 && hour < 18;

    switch (condition) {
      case 'clear':
        return isDay 
          ? 'from-yellow-400 via-orange-400 to-red-400'
          : 'from-purple-900 via-blue-900 to-indigo-900';
      case 'clouds':
        return isDay
          ? 'from-gray-400 via-gray-500 to-gray-600'
          : 'from-gray-700 via-gray-800 to-gray-900';
      case 'rain':
        return 'from-gray-600 via-gray-700 to-gray-800';
      case 'thunderstorm':
        return 'from-gray-800 via-gray-900 to-black';
      case 'snow':
        return 'from-blue-200 via-blue-300 to-blue-400';
      case 'mist':
      case 'fog':
        return 'from-gray-300 via-gray-400 to-gray-500';
      default:
        return 'from-blue-400 via-blue-500 to-blue-600';
    }
  };

  return (
    <div className="fixed inset-0 z-0">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className={`absolute inset-0 bg-gradient-to-br ${getBackgroundGradient()}`}
      />
      
      {/* Animated particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-2 h-2 bg-white/20 rounded-full"
            initial={{
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
            }}
            animate={{
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
            }}
            transition={{
              duration: Math.random() * 10 + 10,
              repeat: Infinity,
              repeatType: 'reverse',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default WeatherBackground;